import React, { useState } from 'react'
import { Card, Row, Col, Form, Input, Button, message } from "antd";
import { MailOutlined } from '@ant-design/icons';
import AppService from 'services/AppService';
import JwtAuthService from 'services/JwtAuthService';
import { useHistory, useParams } from 'react-router-dom';

const backgroundStyle = {
    backgroundImage: 'url(/img/others/img-17.jpg)',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover'
}

const ResetPassword = () => {
    const history=useHistory()
    const {token}=useParams()
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    const onSend = values => {
        setLoading(true)
        JwtAuthService.ResetPassword({...values,token}).then(resp=>{
            
            history.push('/auth')
			setTimeout(() => {
				setLoading(false)
				message.success(resp);
			}, 1500);
        }).catch(e=>{
            
            setTimeout(() => {
				setLoading(false)
				message.error(e?.response?.data);
			}, 1500);
            history.push('/auth')
        })
        

    };

    return (
        <div className="auth-container">

            <div className="h-100" style={backgroundStyle}>
                <div className="container d-flex flex-column justify-content-center h-100">
                    <Row justify="center">
                        <Col xs={20} sm={20} md={20} lg={9}>
                            <Card>
                                <div className="my-2">
                                    <div className="text-center">
                                        <img className="forgotPassLogo" src="/img/One-ATS.svg" alt="" />
                                        <h3 className="mt-3 font-weight-bold">Forgot Password?</h3>
                                        <p className="mb-4">Enter your Email to reset password</p>
                                    </div>
                                    <Row justify="center">
                                        <Col xs={24} sm={24} md={20} lg={20}>
                                            <Form form={form} layout="vertical" name="forget-password" onFinish={onSend}>
                                                <Form.Item
                                                    name="password"
                                                    label="Password"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: 'Please input your password!',
                                                        },
                                                    ]}
                                                    hasFeedback
                                                >
                                                    <Input.Password />
                                                </Form.Item>
                                                <Form.Item
                                                    name="confirm"
                                                    label="Confirm Password"
                                                    dependencies={['password']}
                                                    hasFeedback
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: 'Please confirm your password!',
                                                        },
                                                        ({ getFieldValue }) => ({
                                                            validator(rule, value) {
                                                                if (!value || getFieldValue('password') === value) {
                                                                    return Promise.resolve();
                                                                }
                                                                return Promise.reject('The two passwords that you entered do not match!');
                                                            },
                                                        }),
                                                    ]}
                                                >
                                                    <Input.Password />
                                                </Form.Item>
                                                <Form.Item>
                                                    <Button loading={loading} type="primary" htmlType="submit" block>{loading ? 'resetting password' : 'Reset password'}</Button>
                                                </Form.Item>
                                            </Form>
                                        </Col>
                                    </Row>
                                </div>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </div>
        </div>

    )
}

export default ResetPassword
